import { withProps } from 'recompose';
import Item from './Item';
import { formatPercentage } from '../../utils/format';

const PercentageItem = withProps(({ value }) => ({ value: formatPercentage(value) }))(Item);

export default PercentageItem;
